import { useCallback, useState } from 'react';
import SearchTab from './SearchTab';
import FeedbackDialog from './FeedbackDialog';

// טאב חדש = קובץ XxxTab.jsx + רשומה כאן + case ב-renderTab + פונקציות ב-API (service/ProductsService.js)
const TABS = [
  { key: 'search', label: 'השוואת מחירים' },
];

const s = {
  page:     { maxWidth: 1040, margin: '0 auto', padding: '24px 16px 48px' },
  header:   { marginBottom: 20 },
  topRow:   { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' },
  userBox:  { display: 'flex', alignItems: 'center', gap: 10, color: '#59636e', fontSize: 14 },
  logout:   { padding: '6px 12px', border: '1px solid #d0d7de', borderRadius: 8, background: '#fff', color: '#1f2328', fontSize: 13 },
  title:    { margin: 0, fontSize: 28, fontWeight: 700 },
  subtitle: { margin: '4px 0 0', color: '#59636e' },
  nav:      { display: 'flex', gap: 8, margin: '16px 0 0', borderBottom: '1px solid #e5e7eb' },
  navItem:  { padding: '8px 14px', background: 'none', border: 'none', borderBottom: '2px solid transparent', color: '#59636e' },
  navActive:{ color: '#1f2328', fontWeight: 600, borderBottomColor: '#1f2328' },
  footer:   { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginTop: 40, padding: '20px 16px', borderTop: '1px solid #e5e7eb', color: '#59636e', textAlign: 'center' },
  feedback: { padding: '8px 18px', border: '1px solid #1a3f9c', borderRadius: 10, background: '#fff', color: '#1a3f9c', fontWeight: 600 },
};

// user: { firstName, lastName } של המשתמש המחובר; onLogout — ZolBakfarApp
const MainPage = ({ user, onLogout }) => {
  const [activeTab, setActiveTab] = useState('search');
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  // useCallback: FeedbackDialog נרשם ל-Escape לפי onClose, ולא צריך להירשם מחדש בכל רינדור
  const closeFeedback = useCallback(() => setFeedbackOpen(false), []);

  const renderTab = () => {
    switch (activeTab) {
      case 'search':
      default:
        return <SearchTab />;
    }
  };

  return (
    <div style={s.page}>
      <header style={s.header}>
        <div style={s.topRow}>
          <div>
            <h1 style={s.title}>זול בכפר</h1>
            <p style={s.subtitle}>השוואת מחירים</p>
          </div>
          <div style={s.userBox}>
            <span>שלום, {user?.firstName}</span>
            <button style={s.logout} onClick={onLogout}>יציאה</button>
          </div>
        </div>
        {TABS.length > 1 && (
          <nav style={s.nav}>
            {TABS.map((tab) => (
              <button
                key={tab.key}
                style={{ ...s.navItem, ...(activeTab === tab.key ? s.navActive : null) }}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        )}
      </header>

      {renderTab()}

      <footer style={s.footer}>
        <span>אהבתם? יש לכם רעיון איך אפשר לשפר את האתר?</span>
        <button style={s.feedback} onClick={() => setFeedbackOpen(true)}>שלחו לנו פידבק</button>
      </footer>

      {feedbackOpen && <FeedbackDialog onClose={closeFeedback} />}
    </div>
  );
};

export default MainPage;
